import React, { useRef } from "react";
import { Table } from "react-bootstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";

const StudentStrengthExport = ({
  summary,
  summaryData,
  getRetrainTotal,
  getLeftTotal,
  getSummaryStrengthTotal,
  grandSummary,
  grandLeft,
  grandRetrain,
  reportData,
  grandStrength,
  grandFemale,
  grandMale,
  getStrengthSum,
  getfeMaleSum,
  getMaleSum,
}) => {
  const tableRef = useRef(null);

  return (
    <>
      <DownloadTableExcel
        filename="Student Strength"
        sheet="Student Strength"
        currentTableRef={tableRef.current}
      >
        <button className="btn btn-primary mx-2 mt-9">Export</button>
      </DownloadTableExcel>
      <div id="tableboot mt-5">
        {summary ? (
          <Table ref={tableRef} style={{ display: "none" }}>
            <thead>
              <tr id="tbl">
                <th className="text-center">Class Name</th>
                <th className="text-center">Section Name</th>
                <th className="text-center">Retain</th>
                <th className="text-center">Left</th>
                <th className="text-center">Strength</th>
              </tr>
            </thead>
            <tbody>
              {summaryData.length > 0 ? (
                <React.Fragment>
                  {summaryData.map((item, index) => (
                    <React.Fragment key={index}>
                      {getStrengthSum(item) > 0 ? (
                        <tr id="tbl">
                          <td
                            style={{
                              fontSize: "1.3rem",
                            }}
                            className="text_align_start text-primary"
                          >
                            {item.Campus}
                          </td>
                          <td
                            style={{
                              fontWeight: "bold",
                            }}
                            className=""
                          ></td>
                          <td
                            style={{
                              fontWeight: "bold",
                            }}
                            className="text-center text-primary"
                          >
                            {getRetrainTotal(item)}
                          </td>
                          <td
                            style={{
                              fontWeight: "bold",
                            }}
                            className="text-center text-primary"
                          >
                            {getLeftTotal(item)}
                          </td>
                          <td
                            style={{
                              fontWeight: "bold",
                            }}
                            className="text-center text-primary"
                          >
                            {getSummaryStrengthTotal(item)}
                          </td>
                        </tr>
                      ) : null}
                      {item?.Courses?.map((subitem, subindex) =>
                        subitem?.Classes?.map((element, subsubindex) => (
                          <React.Fragment key={subsubindex}>
                            {element?.Sections?.map((subelement, indu) => (
                              <React.Fragment key={indu}>
                                <tr id="tbl">
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subitem.Course?.name} &nbsp; (
                                    {element?.Class})
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subelement?.Section?.name}
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subelement?.Report?.retain}
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subelement?.Report?.left_students}
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subelement?.Report?.strength}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                            {element?.Sections.length > 0 && (
                              <tr id="tbl">
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text_align_start"
                                ></td>
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text-end"
                                >
                                  Class Wise Totals:-
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text-center"
                                >
                                  {element.Sections.reduce(
                                    (a, c) => a + parseInt(c.Report.retain),
                                    0
                                  )}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text-center"
                                >
                                  {element.Sections.reduce(
                                    (a, c) =>
                                      a + parseInt(c.Report.left_students),
                                    0
                                  )}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text-center"
                                >
                                  {element.Sections.reduce(
                                    (a, c) => a + parseInt(c.Report.strength),
                                    0
                                  )}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      )}
                    </React.Fragment>
                  ))}
                  <tr id="tbl">
                    <td
                      style={{
                        color: "black",
                        fontWeight: "bold",
                      }}
                      className="text_align_start"
                    ></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                      className="text-end text-primary"
                    >
                      Grand Total:-
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                      className="text-center text-primary"
                    >
                      {grandRetrain}
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                      className="text-center text-primary"
                    >
                      {grandLeft}
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                      className="text-center text-primary"
                    >
                      {grandSummary}
                    </td>
                  </tr>
                </React.Fragment>
              ) : null}
            </tbody>
          </Table>
        ) : !summary ? (
          <Table ref={tableRef} style={{ display: "none" }}>
            <thead>
              <tr id="tbl">
                <th className="text-center">Class Name</th>
                <th className="text-center">Section Nmae</th>
                <th className="text-center">Male</th>
                <th className="text-center">Female</th>
                <th className="text-center">Strength</th>
              </tr>
            </thead>
            <tbody>
              {reportData.length > 0 ? (
                <React.Fragment>
                  {reportData.map((item, index) => (
                    <React.Fragment key={index}>
                      {getStrengthSum(item) > 0 ? (
                        <tr id="tbl">
                          <td
                            style={{
                              fontSize: "1.3rem",
                            }}
                            className="text_align_start text-primary"
                          >
                            {item.Campus}
                          </td>
                          <td
                            style={{
                              fontWeight: "bold",
                            }}
                            className=""
                          ></td>
                          <td
                            style={{
                              fontWeight: "bold",
                            }}
                            className="text-center text-primary"
                          >
                            {getMaleSum(item)}
                          </td>
                          <td
                            style={{
                              fontWeight: "bold",
                            }}
                            className="text-center text-primary"
                          >
                            {getfeMaleSum(item)}
                          </td>
                          <td
                            style={{
                              fontWeight: "bold",
                            }}
                            className="text-center text-primary"
                          >
                            {getStrengthSum(item)}
                          </td>
                        </tr>
                      ) : null}
                      {item?.Courses?.map((subitem, subindex) =>
                        subitem?.Classes?.map((element, subsubindex) => (
                          <React.Fragment key={subsubindex}>
                            {element?.Sections?.map((subelement, indu) => (
                              <React.Fragment key={indu}>
                                <tr id="tbl">
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subitem.Course?.name} &nbsp; (
                                    {element?.Class})
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subelement?.Section?.name}
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subelement?.report?.male}
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subelement?.report?.female}
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                    }}
                                    className="text-center"
                                  >
                                    {subelement?.report?.strength}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                            {element?.Sections.length > 0 && (
                              <tr id="tbl">
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text_align_start"
                                ></td>
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text-end"
                                >
                                  Class Wise Totals:-
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text-center"
                                >
                                  {element.Sections.reduce(
                                    (a, c) => a + parseInt(c.report.male),
                                    0
                                  )}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text-center"
                                >
                                  {element.Sections.reduce(
                                    (a, c) => a + parseInt(c.report.female),
                                    0
                                  )}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  className="text-center"
                                >
                                  {element.Sections.reduce(
                                    (a, c) => a + parseInt(c.report.strength),
                                    0
                                  )}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      )}
                    </React.Fragment>
                  ))}
                  <tr id="tbl">
                    <td
                      style={{
                        color: "black",
                        fontWeight: "bold",
                      }}
                      className="text_align_start"
                    ></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                      className="text-end text-primary"
                    >
                      Grand Total:-
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                      className="text-center text-primary"
                    >
                      {grandMale}
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                      className="text-center text-primary"
                    >
                      {grandFemale}
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                      className="text-center text-primary"
                    >
                      {grandStrength}
                    </td>
                  </tr>
                </React.Fragment>
              ) : null}
            </tbody>
          </Table>
        ) : null}
      </div>
    </>
  );
};

export default StudentStrengthExport;
